import svgUrl from "ni:svgr;0O6yAQ7A70EIhrbVkEd8w5OWmWkr7sb_EGPbw9iEEzI";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiPivotSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M7 3h6v3H7V3ZM6 3H3v3h3V3Zm0 4H3v6h3V7ZM2 6V3a1.013 1.013 0 0 1 .134-.5A1.005 1.005 0 0 1 3 2h10a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H7v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6Zm11.992 3.285.569.569a.5.5 0 0 0 .707-.708l-1.415-1.414a.5.5 0 0 0-.707 0l-1.414 1.414a.5.5 0 0 0 .707.708l.55-.55A4 4 0 0 1 9 13V13h-.5a.5.5 0 0 0 0 1H9a5 5 0 0 0 4.992-4.715Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiPivotSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiPivotSIcon)";
}